/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Shipment } from './shipment';


export interface CameraBuild { 
    antenna?: CameraBuild.AntennaEnum;
    cameraExtension?: number;
    cameraSideView?: boolean;
    configConfirmed?: string;
    customerContact?: string;
    customerRefNo?: string;
    failureReason?: string;
    housingLabel?: string;
    housingTypeId?: string;
    manufacturingCompleted?: string;
    orderItemConfigurationId?: string;
    packedAt?: string;
    readyForTest?: string;
    shipment?: Shipment;
    testStart?: string;
    uhfCommunication?: boolean;
    weight?: number;
}
export namespace CameraBuild {
    export const AntennaEnum = {
        Vhf: 'VHF',
        Uhf: 'UHF',
        VhfAndUhf: 'VHF_AND_UHF'
    } as const;
    export type AntennaEnum = typeof AntennaEnum[keyof typeof AntennaEnum];
}


